<template>
  <el-dialog
    :title="$t('businessOpportunityManageMessages.add.title')"
    :visible.sync="visible"
    width="70%"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.opportunityName')"
            prop="opportunityName"
          >
            <el-input
              v-model="form.opportunityName"
              placeholder="请输入商机名称"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.source')"
            prop="source"
          >
            <el-select
              v-model="form.source"
              placeholder="请选择来源"
              style="width: 100%"
              :disabled="!sourceOptions.length"
              filterable
              allow-create
            >
              <el-option
                v-for="item in sourceOptions"
                :key="item.statusCd"
                :label="item.description"
                :value="item.statusCd"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.expectedValue')"
            prop="expectedValue"
          >
            <el-input
              v-model="form.expectedValue"
              placeholder="请输入需求面积"
              style="width: 100%"
              type="number"
            />
          </el-form-item>
          <el-form-item
            :label="
              $t('businessOpportunityManageMessages.add.expectedDealDate')
            "
            prop="expectedDealDate"
          >
            <el-date-picker
              v-model="form.expectedDealDate"
              type="date"
              placeholder="年/月/日"
              style="width: 100%"
              :disabled-date="disabledPastDate"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.opportunityType')"
            prop="opportunityType"
          >
            <el-select
              v-model="form.opportunityType"
              placeholder="请选择商机类型"
              style="width: 100%"
              :disabled="!opportunityTypeOptions.length"
            >
              <el-option
                v-for="item in opportunityTypeOptions"
                :key="item.statusCd"
                :label="item.description"
                :value="item.statusCd"
              />
            </el-select>
          </el-form-item>
          <!-- <el-form-item
            :label="
              $t('businessOpportunityManageMessages.add.negotiationProgress')
            "
            prop="negotiationProgress"
          >
            <el-select
              v-model="form.negotiationProgress"
              placeholder="请选择谈判进度"
              style="width: 100%"
              :disabled="!negotiationProgressOptions.length"
            >
              <el-option
                v-for="item in negotiationProgressOptions"
                :key="item.statusCd"
                :label="item.description"
                :value="item.statusCd"
              />
            </el-select>
          </el-form-item> -->
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.customerName')"
            prop="customerName"
          >
            <el-input
              v-model="form.customerName"
              placeholder="请选择或输入客户名称"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.status')"
            prop="status"
          >
            <el-select
              v-model="form.status"
              placeholder="请选择状态"
              style="width: 100%"
              :disabled="!statusOptions.length"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.statusCd"
                :label="item.description"
                :value="item.statusCd"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="
              $t('businessOpportunityManageMessages.add.responsiblePerson')
            "
            prop="responsiblePerson"
          >
            <el-select
              v-model="form.responsiblePerson"
              placeholder="请选择负责人"
              style="width: 100%"
              filterable
            >
              <el-option
                v-for="user in userOptions"
                :key="user.name"
                :label="user.name"
                :value="user.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.industryType')"
            prop="industryType"
          >
            <el-input
              v-model="form.industryType"
              placeholder="请输入行业类型"
              style="width: 100%"
            />
          </el-form-item>
          <!-- 房源下拉：优先使用父组件传递的roomOptions -->
          <el-form-item
            :label="$t('businessOpportunityManageMessages.add.roomId')"
            prop="roomId"
          >
            <el-select
              v-model="form.roomId"
              placeholder="请选择房源"
              style="width: 100%"
              filterable
              :disabled="!localRoomOptions.length"
            >
              <el-option
                v-for="item in localRoomOptions"
                :key="item.roomId"
                :label="item.roomName"
                :value="item.roomId"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        :label="$t('businessOpportunityManageMessages.add.description')"
        prop="description"
      >
        <el-input
          v-model="form.description"
          type="textarea"
          :rows="4"
          placeholder="请输入商机描述"
          maxlength="500"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item
        :label="$t('businessOpportunityManageMessages.add.attachments')"
        prop="attachments"
      >
        <el-upload
          class="upload-demo"
          drag
          action="/callComponent/upload/uploadFile/uploadImage"
          accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
          :limit="1"
          name="uploadFile"
          :data="uploadExtraParams"
          :file-list="fileList"
          :on-success="handleUploadSuccess"
          :on-remove="handleRemove"
          :auto-upload="true"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">
            支持 PDF, Word, Excel, PPT (单个文件最大 10MB)
          </div>
        </el-upload>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("common.cancel") }}</el-button>
      <el-button type="primary" @click="saveBusinessOpportunity">{{
        $t("common.save")
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  saveBusinessOpportunity,
  selectStaffInfos,
  getRoomInfoByCommunity, // 仅保留兜底加载，正常情况不调用
} from "@/api/businessOpportunity/businessOpportunityApi";
import { getDict } from "@/api/community/communityApi";

export default {
  name: "AddBusinessOpportunity",
  // 新增：接收父组件传递的房源数据（核心优化）
  props: {
    roomOptions: {
      type: Array,
      default: () => [], // 父组件传递房源列表，子组件无需重复查询
    },
  },
  data() {
    return {
      uploadExtraParams: {
        communityId: this.communityId,
      },
      communityId: -1,
      visible: false,
      // 表单基础字段
      form: {
        opportunityName: "",
        customerName: "",
        source: "",
        status: "",
        expectedValue: null,
        responsiblePerson: "",
        roomId: "",
        expectedDealDate: "",
        description: "",
        attachments: "",
        opportunityType: "",
        industryType: "",
        negotiationProgress: "",
      },
      // 字典/下拉数据（房源数据改用父组件传递的roomOptions）
      sourceOptions: [],
      opportunityTypeOptions: [],
      negotiationProgressOptions: [],
      statusOptions: [],
      userOptions: [],
      localRoomOptions: [], // 本地房源数据：优先用父组件的，无则兜底加载
      // 文件上传相关
      fileList: [],
      progress: 0,
      // 数据加载状态标记
      isDictLoaded: false,
      isStaffLoaded: false,
      // 表单校验规则
      rules: {
        opportunityName: [
          { required: true, message: "请输入商机名称", trigger: "blur" },
          { max: 100, message: "商机名称最多100个字符", trigger: "blur" },
        ],
        customerName: [
          { required: true, message: "请选择或输入客户名称", trigger: "blur" },
        ],
        source: [
          { required: true, message: "请选择商机来源", trigger: "change" },
        ],
        status: [
          { required: true, message: "请选择商机状态", trigger: "change" },
        ],
        expectedValue: [
          { required: true, message: "请输入需求面积", trigger: "blur" },
          { min: 0.01, message: "需求面积必须大于0", trigger: "blur" },
        ],
        responsiblePerson: [
          { required: true, message: "请选择负责人", trigger: "change" },
        ],
        expectedDealDate: [
          { required: false, message: "请选择预计成交日期", trigger: "change" },
        ],
        description: [
          { max: 500, message: "商机描述最多500个字符", trigger: "blur" },
        ],
        roomId: [{ required: true, message: "请选择房源", trigger: "change" }],
      },
    };
  },
  created() {
    // 预加载字典+负责人数据（仅一次）
    this.preloadBaseData();
  },
  methods: {
    /**
     * 预加载基础数据（字典+负责人），组件生命周期内仅执行一次
     */
    async preloadBaseData() {
      try {
        await Promise.all([this.loadDictData(true), this.loadStaffData(true)]);
      } catch (error) {
        this.$message.warning("基础数据加载失败，打开弹窗时将自动重试");
        console.error("预加载基础数据异常:", error);
      }
    },

    /**
     * 打开弹窗：仅重置表单+同步父组件的房源数据，无需重复请求
     */
    async open() {
      this.visible = true;
      this.resetForm(); // 重置表单残留数据

      try {
        // 1. 同步父组件传递的房源数据（核心：无需查询接口）
        if (this.roomOptions.length > 0) {
          this.localRoomOptions = this.roomOptions;
          console.log(
            "使用父组件传递的房源数据，无需重复查询:",
            this.localRoomOptions,
          );
        } else {
          // 2. 兜底：父组件未传递时，才加载房源数据（避免极端情况为空）
          await this.loadRoomDataFallback();
        }

        // 3. 仅在字典/负责人未加载时重试（避免重复请求）
        if (!this.isDictLoaded) await this.loadDictData(true);
        if (!this.isStaffLoaded) await this.loadStaffData(true);
      } catch (error) {
        this.$message.warning("部分数据加载失败，可能影响操作");
        console.error("弹窗数据加载异常:", error);
      }
    },

    /**
     * 重置表单状态（清空输入+文件列表）
     */
    resetForm() {
      if (this.$refs.form) this.$refs.form.resetFields();
      this.form = {
        opportunityName: "",
        customerName: "",
        source: "",
        status: "",
        expectedValue: null,
        responsiblePerson: "",
        roomId: "",
        expectedDealDate: "",
        description: "",
        attachments: "",
        opportunityType: "",
        industryType: "",
        negotiationProgress: "",
      };
      this.fileList = [];
      this.progress = 0;
      this.localRoomOptions = []; // 重置本地房源数据
    },

    /**
     * 加载字典数据（支持强制刷新）
     */
    async loadDictData(forceRefresh = false) {
      if (this.isDictLoaded && !forceRefresh) return;

      try {
        // 修正谈判进度字典名拼写（negotiatio_progress → negotiation_progress）
        const [sourceDict, statusDict, opportunityDict, negotiationDict] =
          await Promise.all([
            getDict("business_opportunity_source", "audit"),
            getDict("business_opportunity_status", "audit"),
            getDict("opportunity_type", "audit"),
            getDict("negotiation_progress", "audit"),
          ]);

        this.sourceOptions = sourceDict.filter((item) => item.statusCd);
        this.statusOptions = statusDict.filter((item) => item.statusCd);
        this.opportunityTypeOptions = opportunityDict.filter(
          (item) => item.statusCd,
        );
        this.negotiationProgressOptions = negotiationDict.filter(
          (item) => item.statusCd,
        );
        this.isDictLoaded = true;
      } catch (error) {
        this.isDictLoaded = false;
        console.error("字典数据加载异常:", error);
        throw error;
      }
    },

    /**
     * 加载负责人数据（支持强制刷新）
     */
    async loadStaffData(forceRefresh = false) {
      if (this.isStaffLoaded && !forceRefresh) return;

      try {
        const params = {
          page: 1,
          row: 1000,
          ...this.conditions,
        };
        const res = await selectStaffInfos(params);
        this.userOptions = res.staffs || [];
        this.isStaffLoaded = true;
      } catch (error) {
        this.isStaffLoaded = false;
        console.error("负责人数据加载异常:", error);
        throw error;
      }
    },

    /**
     * 兜底：父组件未传递房源数据时，才调用接口加载（避免重复查询）
     */
    async loadRoomDataFallback() {
      try {
        console.log("父组件未传递房源数据，执行兜底加载");
        const res = await getRoomInfoByCommunity();
        this.localRoomOptions = res || [];
      } catch (error) {
        console.error("房源数据兜底加载异常:", error);
        this.localRoomOptions = [];
        throw error;
      }
    },

    /**
     * 文件上传成功回调
     */
    handleUploadSuccess(response, file) {
      if (response.data.url) {
        file.url = response.data.url;
        this.fileList = [file];
        this.$message.success("文件上传成功");
      } else {
        this.$message.error("文件上传失败：未获取到文件地址");
      }
    },

    /**
     * 移除已上传文件
     */
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.form.attachments = "";
    },

    /**
     * 保存商机数据
     */
    async saveBusinessOpportunity() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;

        try {
          const attachmentUrls = this.fileList
            .filter((file) => file.url)
            .map((file) => file.url)
            .join(",");
          this.form.attachments = attachmentUrls;

          const res = await saveBusinessOpportunity(this.form);
          if (res.code === 0) {
            this.$message.success("商机保存成功");
            this.handleClose();
            this.$emit("success"); // 通知父组件刷新数据
          } else {
            this.$message.error(res.msg || "商机保存失败");
          }
        } catch (error) {
          this.$message.error("操作失败：" + error.message);
          console.error("保存商机异常:", error);
        }
      });
    },

    /**
     * 禁用过去日期
     */
    disabledPastDate(date) {
      return date && date < new Date(new Date().setHours(0, 0, 0, 0));
    },

    /**
     * 关闭弹窗：重置状态
     */
    handleClose() {
      this.visible = false;
      this.resetForm();
    },

    /**
     * 外部调用：强制刷新字典数据
     */
    async refreshDict() {
      await this.loadDictData(true);
      await this.loadStaffData(true);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload__tip {
  margin-top: 6px;
  font-size: 13px;
  color: #606266;
}

::v-deep .el-form-item__content {
  line-height: 1.2;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding: 12px 24px 24px;
  margin-top: 12px;
}

::v-deep .el-upload-dragger {
  padding: 30px 0;
}
</style>
